import Hashids from 'hashids';

const hashids = new Hashids('scout', 8, 'abcdefghijklmnopqrstuvwxyz1234567890');

export const encodeCandidateId =
    (candidateId: number | string) => hashids.encode(String(candidateId));